interface ISnAvatarConfig {
  src?: string;
  name?: string;
  value?: string;
  size?: number;
  initialsSize?: number;
  textSizeRatio?: number;
  bgColor?: string;
}

export type SnAvatarConfig = ISnAvatarConfig;
